import * as Yup from 'yup';

export const createLessonSchema = Yup.object().shape({
  title: Yup.object().shape({
    uz: Yup.string().required('Nomi (uz) majburiy'),
    ru: Yup.string().required('Nomi (ru) majburiy'),
    en: Yup.string().required('Nomi (en) majburiy'),
  }),
  description: Yup.object().shape({
    uz: Yup.string().required("Taglavha (uz) majburiy"),
    ru: Yup.string().required('Taglavha (ru) majburiy'),
    en: Yup.string().required('Taglavha (en) majburiy'),
  }),
  text: Yup.object().shape({
    uz: Yup.string().required('Matn (uz) majburiy'),
    ru: Yup.string().required('Matn (ru) majburiy'),
    en: Yup.string().required('Matn (en) majburiy'),
  }),
  image: Yup.mixed().required('Rasmni tanlang'),
});
